import React, { useEffect } from "react";
import Header from "../Frontend/Header";
import Footer from "../Frontend/Footer";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { trackMetaEvent, trackTikTokEvent } from "util/analytics";

const LeadThanks = () => {

  useEffect(() => {
   
    trackMetaEvent('Lead');
    trackTikTokEvent('SubmitForm');
  }, []);

  return (
    <React.Fragment>
      <Helmet>
        <title>Language Academy</title>
      </Helmet>
      <Header />
      <div className="innerPage">
        <section className="bannerOuter">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 text-center">
                <div className="thankyou-inner">
                  <h2 className="header">
                    <b>
                      <i className="fa fa-check-circle" aria-hidden="true"></i>{" "}
                      &nbsp;&nbsp;Thank You!
                    </b>
                  </h2>
                  <p>
                    Your details have been submitted successfully.
                    <br />
                  </p>
                </div>
                <span></span>
                <br />
              </div>
            </div>
          </div>
        </section>
      </div>
      <section id="pte-modules" className="mt-5">
        <div className="container">
          <div className="row text-center"></div>
        </div>
      </section>
      <Footer />
    </React.Fragment>
  );
};

export default LeadThanks;